import { useCurrency } from "@/context/CurrencyContext";

const LABEL = { INR: "\u20b9 INR", USD: "$ USD", EUR: "\u20ac EUR", GBP: "\u00a3 GBP" };

export default function CurrencyToggle({ className = "" }) {
  const { currency, setCurrencyManual, allowedCurrencies } = useCurrency();
  const options = allowedCurrencies && allowedCurrencies.length ? allowedCurrencies : ["INR"];

  // Only one currency allowed (India → INR, non-India → USD): render as a static badge
  if (options.length === 1) {
    return (
      <div
        className={`inline-flex items-center border border-[#09090b] bg-[#ea580c] text-white text-[10px] md:text-xs font-bold px-2 py-1 md:px-2.5 md:py-1 ${className}`}
        data-testid="currency-badge"
      >
        {LABEL[options[0]] || options[0]}
      </div>
    );
  }

  return (
    <div
      className={`inline-flex border border-[#09090b] text-[10px] md:text-xs font-bold overflow-hidden ${className}`}
      data-testid="currency-toggle"
    >
      {options.map((c, i) => (
        <button
          key={c}
          onClick={() => setCurrencyManual(c)}
          className={`px-2 py-1 md:px-2.5 md:py-1 transition-colors ${i > 0 ? "border-l border-[#09090b]" : ""} ${currency === c ? "bg-[#ea580c] text-white" : "text-[#09090b] hover:bg-[#f4f4f5]"}`}
          data-testid={`currency-${c.toLowerCase()}-btn`}
        >
          {LABEL[c] || c}
        </button>
      ))}
    </div>
  );
}
